import * as React from 'react';

export const useDelayedTooltipBiEvent = (onTooltipViewed: () => void) => {
  const [timeoutId, setTimeoutId] = React.useState<number | null>(null);

  const logShowTooltipDelayedEvent = (delay: number = 2000) =>
    setTimeoutId(window.setTimeout(onTooltipViewed, delay));

  const interuptTooltipDelayedEvent = () =>
    !!timeoutId && clearTimeout(timeoutId);

  React.useEffect(
    () => () => {
      interuptTooltipDelayedEvent();
    },
    [],
  );
  return { logShowTooltipDelayedEvent, interuptTooltipDelayedEvent };
};
